import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";

export const subscriptionCouponModel = {
  id: String,
  percentOff: Optional(Number),
  amountOff: Optional(Number),
  duration: String,
  durationInMonths: Optional(Number),
  isValid: Boolean,
  isDeleted: Boolean,
} satisfies ModelDefinition;

export const SubscriptionCouponModel = createModel({
  data: {
    checkCoupon: subscriptionCouponModel,
  },
}).transform(subscriptionCouponModel, (data) => data.data.checkCoupon);

export interface SubscriptionCoupon
  extends FromModel<typeof SubscriptionCouponModel> {}
